import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const keyString = '*hY6p#7mw6&eTMel';

@Injectable({
  providedIn: 'root'
})
export class EncrDecrService {
  constructor() {}

  enCryption(value: string): string {
    const key: any = CryptoJS.enc.Utf8.parse(keyString);

    const cipherText: any = CryptoJS.AES.encrypt(value, key, {
      keySize: 128,
      mode: CryptoJS.mode.ECB
    });

    return cipherText.toString();
  }

  deCryption(value: string): string {
    const key: any = CryptoJS.enc.Utf8.parse(keyString);
    const plaintext: any = CryptoJS.AES.decrypt(this.decodeValue(value), key, {
      keySize: 128,
      mode: CryptoJS.mode.ECB
    });
    return plaintext.toString(CryptoJS.enc.Utf8);
  }

  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
